"use strict";

/* pfVer 6.6-rc-16-SNAPSHOT.*/
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Attendancecategory = exports.Recipient = exports.Upload = exports.FinrecImport = exports.Currency = exports.Financepositiongroup = exports.CancellationPosition = exports.CorrectiveinvoicePosition = exports.Financeposition = exports.InvoicePosition = exports.ContractPosition = exports.OfferPosition = exports.AbstractFinancePosition = exports.Invoice = exports.Contract = exports.Offer = exports.AbstractPurchaseFinanceRecord = exports.AbstractSalesFinanceRecord = exports.AbstractFinanceRecord = exports.Testaccount = exports.Expense = exports.Lastused = exports.Share = exports.Image = exports.Attachment = exports.FileData = exports.ApiFileRepresentation = exports.File = exports.ErrorMessage = exports.SystemMessage = exports.Organization = exports.Crmactivity = exports.Password = exports.CustomFieldValue = exports.Contactfield = exports.Contact = exports.Chatgroup = exports.Chatmessage = exports.Projecthistory = exports.Projectfolder = exports.Project = exports.TicketState = exports.TicketCustomInput = exports.TicketChannel = exports.TicketProcess = exports.Ticket = exports.Timecategory = exports.Timetemplate = exports.Time = exports.AbstractTime = exports.Day = exports.Notification = exports.CiCo = exports.User = exports.Externalaccess = exports.Interface = exports.Device = exports.Index = exports.Enum = exports.PfCollection = exports.PfDTO = exports.EntityTag = exports.APILinkObject = exports.ImageInlineData = void 0;
class ImageInlineData {}
exports.ImageInlineData = ImageInlineData;
/**
 * Relations are described with Objects, containing at least a value,
 * which identifies the related object.
 */
class APILinkObject {
  constructor(json) {
    if (json != null) {
      for (let field in json) {
        this[field] = json[field];
      }
    }
  }
  /** clones this Object */
  exportApiLink() {
    return new APILinkObject({
      href: this.href,
      rel: this.rel,
      idKey: this.idKey,
      caption: this.caption,
      color: this.color,
      value: this.value
    });
  }
  /** used to convert 'dead' js-objects (e.g. from localstorage) into 'living' APILinkObjects */
  static exportApiLink(object) {
    return object ? new APILinkObject({
      href: object.href,
      rel: object.rel,
      idKey: object.idKey,
      caption: object.caption,
      color: object.color,
      value: object.value
    }) : null;
  }
}
exports.APILinkObject = APILinkObject;
class EntityTag {}
exports.EntityTag = EntityTag;
class PfDTO {}
exports.PfDTO = PfDTO;
class PfCollection extends PfDTO {}
exports.PfCollection = PfCollection;
class Enum extends PfDTO {}
exports.Enum = Enum;
class Index extends PfCollection {}
exports.Index = Index;
class Device extends PfDTO {}
exports.Device = Device;
class Interface extends PfDTO {}
exports.Interface = Interface;
class Externalaccess extends PfDTO {
  constructor() {
    super(...arguments);
    this.active = true;
    this.thirdParty = 0; // int
    this.accessTickets = false;
    this.accessProjects = false;
    this.accessFiles = false;
    this.accessInvoices = false;
  }
}
exports.Externalaccess = Externalaccess;
class User extends PfDTO {}
exports.User = User;
class CiCo extends PfDTO {}
exports.CiCo = CiCo;
class Notification extends PfDTO {}
exports.Notification = Notification;
class Day extends PfDTO {}
exports.Day = Day;
class AbstractTime extends PfDTO {}
exports.AbstractTime = AbstractTime;
class Time extends AbstractTime {}
exports.Time = Time;
class Timetemplate extends AbstractTime {}
exports.Timetemplate = Timetemplate;
class Timecategory extends PfDTO {}
exports.Timecategory = Timecategory;
class Ticket extends PfDTO {}
exports.Ticket = Ticket;
class TicketProcess extends PfDTO {}
exports.TicketProcess = TicketProcess;
class TicketChannel extends PfDTO {}
exports.TicketChannel = TicketChannel;
class TicketCustomInput extends PfDTO {}
exports.TicketCustomInput = TicketCustomInput;
class TicketState extends PfDTO {}
exports.TicketState = TicketState;
class Project extends PfDTO {}
exports.Project = Project;
class Projectfolder extends PfDTO {}
exports.Projectfolder = Projectfolder;
class Projecthistory extends PfDTO {}
exports.Projecthistory = Projecthistory;
class Chatmessage extends PfDTO {}
exports.Chatmessage = Chatmessage;
class Chatgroup extends PfDTO {}
exports.Chatgroup = Chatgroup;
class Contact extends PfDTO {
  constructor() {
    super(...arguments);
    this.active = true;
    this.person = true;
    this.externalAccessSettings = false;
  }
}
exports.Contact = Contact;
class Contactfield extends PfDTO {}
exports.Contactfield = Contactfield;
class CustomFieldValue extends PfDTO {}
exports.CustomFieldValue = CustomFieldValue;
class Password extends PfDTO {}
exports.Password = Password;
class Crmactivity extends PfDTO {}
exports.Crmactivity = Crmactivity;
class Organization extends PfDTO {}
exports.Organization = Organization;
class SystemMessage extends PfDTO {}
exports.SystemMessage = SystemMessage;
class ErrorMessage extends SystemMessage {}
exports.ErrorMessage = ErrorMessage;
class File extends PfDTO {}
exports.File = File;
class ApiFileRepresentation extends PfDTO {}
exports.ApiFileRepresentation = ApiFileRepresentation;
class FileData extends ApiFileRepresentation {}
exports.FileData = FileData;
class Attachment extends ApiFileRepresentation {}
exports.Attachment = Attachment;
class Image extends FileData {}
exports.Image = Image;
class Share extends PfDTO {}
exports.Share = Share;
class Lastused extends PfDTO {}
exports.Lastused = Lastused;
class Expense extends PfDTO {}
exports.Expense = Expense;
class Testaccount extends PfDTO {}
exports.Testaccount = Testaccount;
class AbstractFinanceRecord extends PfDTO {}
exports.AbstractFinanceRecord = AbstractFinanceRecord;
class AbstractSalesFinanceRecord extends AbstractFinanceRecord {}
exports.AbstractSalesFinanceRecord = AbstractSalesFinanceRecord;
class AbstractPurchaseFinanceRecord extends AbstractFinanceRecord {}
exports.AbstractPurchaseFinanceRecord = AbstractPurchaseFinanceRecord;
class Offer extends AbstractSalesFinanceRecord {}
exports.Offer = Offer;
class Contract extends AbstractSalesFinanceRecord {}
exports.Contract = Contract;
class Invoice extends AbstractSalesFinanceRecord {}
exports.Invoice = Invoice;
class AbstractFinancePosition extends PfDTO {
  constructor() {
    super(...arguments);
    this.discount = 0; // percent (0 to 100)
    this.taxPercent = 0; // percent (0 to 100)
  }
}
exports.AbstractFinancePosition = AbstractFinancePosition;
class OfferPosition extends AbstractFinancePosition {}
exports.OfferPosition = OfferPosition;
class ContractPosition extends AbstractFinancePosition {}
exports.ContractPosition = ContractPosition;
class InvoicePosition extends AbstractFinancePosition {}
exports.InvoicePosition = InvoicePosition;
class Financeposition extends PfDTO {}
exports.Financeposition = Financeposition;
class CorrectiveinvoicePosition extends AbstractFinancePosition {}
exports.CorrectiveinvoicePosition = CorrectiveinvoicePosition;
class CancellationPosition extends AbstractFinancePosition {}
exports.CancellationPosition = CancellationPosition;
class Financepositiongroup extends PfDTO {
  constructor() {
    super(...arguments);
    this.headerActive = true;
    this.footerActive = true;
    this.positionsActive = 1; // Integer
    this.startOnNewPage = false;
  }
}
exports.Financepositiongroup = Financepositiongroup;
class Currency extends PfDTO {}
exports.Currency = Currency;
class FinrecImport extends PfDTO {}
exports.FinrecImport = FinrecImport;
class Upload extends PfDTO {}
exports.Upload = Upload;
class Recipient extends PfDTO {}
exports.Recipient = Recipient;
class Attendancecategory extends PfDTO {}
exports.Attendancecategory = Attendancecategory;
